<template>
  <v-layout row wrap class="pt-2" data-qa="loantransactions-layout-cp061">
    <v-overlay v-if="loaderEnabled" :opacity="0.5" data-qa="loantransactions-overlay-hkcp2l">
      <v-progress-circular
        :color="primaryColor"
        :size="70"
        :width="7"
        indeterminate
        class="circular-loader"
       data-qa="loantransactions-progress-circular-74beo8"></v-progress-circular>
    </v-overlay>

    <v-flex xs12 sm12 md12 lg8 xl8 class="pb-2" v-if="showCustomList" data-qa="loantransactions-flex-0h2vyn">
      <v-flex xs12 sm12 md12 lg12 xl12 class="pa-1" data-qa="loantransactions-flex-391je">
        <v-chip-group v-model="defaultFilter" :color="primaryColor" mandatory data-qa="loantransactions-chip-group-tmrdf">
          <v-chip outlined class="ma-2" @click="showCustomFilterList(); resetFormattedDate();" data-qa="loantransactions-chip-bk3h7q">{{
            $t("accountTransaction.customFilter")
          }}</v-chip>
          <v-chip
            v-if="chip3"
            outlined
            class="ma-2"
            @click="last3MonthTransactions"
           data-qa="loantransactions-chip-qhsxqk">
            {{ $t("accountTransaction.last3Months") }}
          </v-chip>
          <v-chip
            v-if="chip1"
            outlined
            class="ma-2"
            @click="last6MonthTransactions"
           data-qa="loantransactions-chip-73yjus5">
            {{ $t("accountTransaction.last6Months") }}
          </v-chip>
          <v-chip
            v-if="chip2"
            outlined
            class="ma-2"
            @click="last9MonthTransactions"
           data-qa="loantransactions-chip-cqp54a">
            {{ $t("accountTransaction.last9Months") }}
          </v-chip>
          <v-chip v-if="chip4" outlined class="ma-2" @click="tenorTransactions" data-qa="loantransactions-chip-mvry1o">
            {{ $t("accountTransaction.tenorFilter") }}
          </v-chip>
        </v-chip-group>
      </v-flex>
      <v-expand-x-transition data-qa="loantransactions-expand-x-transition-qtol7">
        <v-flex xs12 sm12 md8 lg8 xl8 data-qa="loantransactions-flex-xgaom">
          <v-row no-gutters v-show="expandCustomList" data-qa="loantransactions-row-vrxnzj">
            <v-flex class="pl-4 pr-4 md-4" xs5 sm5 md5 lg5 xl5 data-qa="loantransactions-flex-2fdwir">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="loantransactions-menu-hvdt6e">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedFromDate"
                    :label="$t('accountTransaction.fromDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="fromDate"
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDate"
                  @input="menu = false"
                  :allowed-dates="allowedDates"
                  :min="minAllowedDate"
                  :max="currentDate"
                  data-qa="fromDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex class="pl-4 pr-2 md-4" xs5 sm5 md5 lg5 xl5 data-qa="loantransactions-flex-3t8ojc">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
               data-qa="loantransactions-menu-wx9kjzm">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formattedToDate"
                    :label="$t('accountTransaction.toDate')"
                    append-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    data-qa="toDate"
                    :color="primaryColor"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="toDate"
                  @input="menu2 = false"
                  :allowed-dates="allowedDates"
                  :min="minAllowedDate"
                  :max="maxAllowedDate"
                  data-qa="toDate"
                  :color="primaryColor"
                  @change="updateFormattedDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs1 sm1 md2 lg1 xl1 class="pl-2 pr-4 pt-4 md-4" data-qa="loantransactions-flex-k3gcd">
              <v-btn
                fab
                outlined
                small
                :color="primaryColor"
                @click="getCustomTransactions(fromDate, toDate, 'fromCustomFilter')"
                data-qa="getCustomTransaction"
              >
                <v-icon dark class="material-symbols-outlined" data-qa="loantransactions-icon-o2prnp">arrow_right_alt</v-icon>
              </v-btn>
            </v-flex>
          </v-row>
        </v-flex>
      </v-expand-x-transition>
    </v-flex>

    <v-flex xs12 sm12 md12 lg6 xl6 class="pa-4" v-if="dateError" data-qa="loantransactions-flex-r6j3bq">
      <div class="text-left" data-qa="loantransactions-div-ih6a9j">
        <v-alert icon="mdi-alert-circle" class="v-alert--error" data-qa="loantransactions-alert-yx7q5b">
          <font class="body-2" :color="errorColor">{{
            $t("accountTransaction.transactionError")
          }}</font>
        </v-alert>
      </div>
    </v-flex>
    <v-flex xs12 sm12 md12 lg6 xl6 class="pa-4" v-if="loanStartDateError && !dateError" data-qa="loantransactions-flex-wn6dpp">
      <div class="text-left" data-qa="loantransactions-div-vw6itn">
        <v-alert icon="mdi-alert-circle" class="v-alert--error" data-qa="loantransactions-alert-4vnf5c">
          <font class="body-2" :color="errorColor">{{
            $t("accountTransaction.loanStartDateError")
          }}</font>
        </v-alert>
      </div>
    </v-flex>
    <v-flex xs12 sm12 md12 lg12 xl12 class="pa-2 pl-0 ml-3" v-if="showList && !loanStartDateError" data-qa="loantransactions-flex-5446gi">
      <!--Show card view for all accounts-->
      <div id="pdfLoanContent" data-qa="loantransactions-div-0tw9fb">
        <v-card class="text-left" max-width="600" data-qa="loantransactions-card-1gre8t">
          <div v-for="(item, i) in items" :key="item.transactionId" :data-qa="`loantransactions-div-0tw0fb-${i}`">
            <div
              v-if="
                ((transactionReversalIndicator) || (transactionReversalIndicator === false &&
                item.reversalIndicator? item.reversalIndicator === false: true))
              "
              :data-qa="`loantransactions-div-c1wn-${i}`">
              <!-- <div class="overline text-left" data-qa="loantransactions-div-ig53yb">{{ $formatter.formatDate(item.bookingDateTime.substr(0, 10)) }}</div> -->
              <!--All repeated item content-->
              <v-list-item two-line v-if="!hideTransactionList.includes(item.description)" :data-qa="`loantransactions-list-item-cf16xj-${i}`">
                <v-list-item-content :data-qa="`loantransactions-list-item-content-6iodxe-${i}`">
                  <div class="overline mb-0" :data-qa="`loantransactions-div-p1jhda-${i}`">
                    <v-icon
                      color="green"
                      v-if="item.creditDebitIndicator === 'CREDIT'"
                      :data-qa="`loantransactions-icon-qur2op-${i}`">mdi-arrow-bottom-right</v-icon
                    >
                    <v-icon color="red" v-else :data-qa="`loantransactions-icon-kzq7xc-${i}`">mdi-arrow-top-left </v-icon>
                    <font class="subtitle-2 font-weight-normal ml-2">{{
                      checkLoanDescription(item.description)
                    }}</font>
                  </div>
                  <!-- <v-list-item-subtitle class="mb-1 ml-8"
                     data-qa="loantransactions-list-item-subtitle-qs5cx">Transaction ID:
                    {{ item.transactionId }}</v-list-item-subtitle
                  > -->
                  <v-list-item-subtitle class="mb-0 ml-8" :data-qa="`loantransactions-list-item-subtitle-gdmhrd-${i}`">{{
                    $formatter.formatDate(item.valueDateTime.substr(0, 10))
                  }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action :data-qa="`loantransactions-list-item-action-kgctba-${i}`">
                  <v-list-item-action-text :data-qa="`loantransactions-list-item-action-text-pjn0h-${i}`">
                    <font
                      :color="getColor(item.creditDebitIndicator)"
                      class="subtitle-1 font-weight-bold"
                      >{{
                        $formatter.currency.format(item.amount.amount, item.amount.currency)
                      }}</font
                    >
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
              <!--End repeated-->
              <v-divider v-if="!hideTransactionList.includes(item.description)" :data-qa="`loantransactions-divider-0f4nk9-${i}`"></v-divider>
            </div>
          </div>
        </v-card>
      </div>
      <!--end card view-->
      <v-flex xs12 sm12 md6 lg6 xl6 class="pa-2" v-if="items && items.length" data-qa="loantransactions-flex-x6y4hg">
        <v-pagination
          @input="paginationChangeHandler"
          :value="pagination.page"
          :length="pageNumbers"
          :total-visible="6"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
         data-qa="loantransactions-pagination-t1xa36"></v-pagination>
      </v-flex>
      <v-flex xs12 sm12 md8 lg6 xl6 class="text-left" v-else data-qa="loantransactions-flex-1m8z13">
        <v-alert v-if="!dateError && !loanStartDateError" icon="mdi-information-outline" class="v-alert--info" data-qa="loantransactions-alert-eozdi">
          <font class="body-2">
            {{ $t("accountTransaction.noTransactions") }}
          </font>
        </v-alert>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<style lang="scss" scoped>
#pdfLoanContent {
  width: 100%;
  height: auto;
  display: block;
}
</style>

<script>
import commonService from '@/service/commonService.js'
import preload from '@/util/preload'
import html2canvas from 'html2canvas'
import _ from 'lodash'
import moment from 'moment'
const { jsPDF } = require('jspdf')

export default {
  name: 'LoanTransactions',
  props: {
    loanConfig: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      chip1: true,
      chip2: true,
      chip3: true,
      chip4: this.$appSettings.defaultConfigurations.loanScreen.enableLoanTenorFilter,
      expandCustomList: false,
      items: [],
      itemLinks: {},
      itemGroups: {},
      showList: false,
      loaderEnabled: false,
      showCustomFilter: true,
      loading: false,
      enableLinks: false,
      loanStartDate: null,
      transactionReversalIndicator: this.$appSettings.defaultConfigurations
        .includeReversedTransactionInHistory,
      hideTransactionList: this.$appSettings.uiFieldsDisplayConfigurations.hideLoanTransactionList.exclusionList,
      itemsPerPage: 20,
      offset: 0,
      pageNumbers: 2,
      startDate: '',
      endDate: '',
      loanId: undefined,
      pagination: { rowsPerPage: 20, page: 1 },
      fromDate: '',
      toDate: '',
      maxAllowedDate: '',
      currentDate: moment().format('YYYY-MM-DD'),
      minAllowedDate: moment().subtract(parseInt(this.$appSettings.defaultConfigurations.transactionCustomFilter.minAllowedDays.loans), 'days').format('YYYY-MM-DD'),
      showCustomList: true,
      defaultFilter: 1,
      dateError: false,
      loanStartDateError: false,
      menu: false,
      menu2: false,
      select: { state: 'Select Date Range', val: 'custom' },
      headers: [
        {
          text: 'Date',
          value: 'valueDateTime',
          sortable: false,
          filterable: false
        },
        {
          text: 'Transaction Id',
          value: 'transactionId',
          sortable: false,
          filterable: false
        },
        {
          text: 'Transaction Description',
          value: 'description',
          sortable: false,
          filterable: false
        },
        {
          text: 'Dr/Cr',
          value: 'creditDebitIndicator',
          sortable: true,
          filterable: true,
          align: 'center'
        },
        {
          text: 'Amount',
          value: 'amount.amount',
          sortable: false,
          filterable: false
        },
        {
          text: 'Balance',
          value: 'clearedBalance.amount',
          sortable: false,
          filterable: false
        }
      ]
    }
  },
  created () {
    this.loanId = this.$route.params.loanId
    this.setDates()
    this.updateFormattedDate()
    const exclusionList = this.$appSettings.uiFieldsDisplayConfigurations
      .tableColumns.transactionsTable.exclusionList
    if (exclusionList && exclusionList.length) {
      this.headers = preload.filterTableColumns(exclusionList, this.headers)
    }
    if (this.loanId) {
      this.last3MonthTransactions()
    }
  },
  methods: {
    allowedDates: (val) => parseInt(val.split('-')[2], 10) % 1 === 0,
    setDates () {
      this.fromDate = ''
      this.toDate = ''
      this.maxAllowedDate = ''
      this.fromDate = this.loanConfig.loanMaturityDate < this.currentDate
        ? this.loanConfig.loanMaturityDate
        : moment().format('YYYY-MM-DD')
      this.toDate = this.loanConfig.loanMaturityDate < this.currentDate
        ? this.loanConfig.loanMaturityDate
        : moment().format('YYYY-MM-DD')
      this.maxAllowedDate = this.loanConfig.loanMaturityDate
      this.updateFormattedDate()
    },
    async getTransactions (loanId, startDate, endDate, limit, offset) {
      if (loanId) {
        const response = await commonService.getLoanTransactions(
          loanId,
          startDate,
          endDate,
          limit,
          offset
        )
        if (response) {
          return response
        }
      }
    },
    updateFormattedDate () {
      this.formattedFromDate = this.$formatter.formatDate(this.fromDate)
      this.formattedToDate = this.$formatter.formatDate(this.toDate)
    },
    resetFormattedDate () {
      this.setDates()
      // this.formattedFromDate = this.$formatter.formatDate(this.currentDate)
      // this.formattedToDate = this.$formatter.formatDate(this.currentDate)
    },
    showTransactions (val) {
      const self = this
      this.dateError = false
      this.pageNumbers = 2
      this.offset = 0
      if (val === 'custom') {
        this.showCustomList = true
        this.showList = false
      } else {
        const startDate = moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
        const endDate = moment().format('YYYY-MM-DD')
        this.showCustomList = false
        this.startDate = startDate
        this.endDate = endDate
        this.pagination.page = 1
        this.getTransactions(
          this.loanId,
          this.startDate,
          this.endDate,
          this.itemsPerPage,
          this.offset
        ).then((response) => {
          self.setData(response)
          self.items = response.items
          self.itemLinks = response.links
          self.showList = true
        })
      }
    },
    getCustomTransactions (startDate, endDate, fromFilter = undefined) {
      const self = this
      this.startDate = startDate
      this.endDate = endDate
      this.pageNumbers = 2
      this.offset = 0
      this.loanStartDateError = false
      if (startDate < this.loanConfig.loanStartDate && fromFilter && fromFilter === 'fromCustomFilter') {
        this.loanStartDateError = true
      }
      if (startDate > endDate) {
        this.dateError = true
      } else {
        this.dateError = false
        if (this.offset === 0) {
          this.pagination.page = 1
        }
        self
          .getTransactions(
            this.loanId,
            startDate,
            endDate,
            this.itemsPerPage,
            this.offset
          )
          .then((response) => {
            self.setData(response)
            self.items = response.items
            self.itemLinks = response.links
            self.itemGroups = self.getItemGroup(self.items)
            self.showList = true
          })
      }
    },
    getColor (status) {
      return status === 'DEBIT' ? 'red' : 'green'
    },
    checkLoanDescription (desc) {
      switch (desc) {
        case this.$t('accountTransaction.loanDescription.surplusAppropriation'):
          return this.$t('accountTransaction.loanDescription.excessAmountPayment')
        default:
          return desc
      }
    },
    paginationChangeHandler (pageNumber) {
      this.pagination.page = pageNumber
      if (this.pagination.page >= 1) {
        this.offset = (this.pagination.page - 1) * this.itemsPerPage
        this.getTransactions(
          this.loanId,
          this.startDate,
          this.endDate,
          this.itemsPerPage,
          this.offset
        ).then((response) => {
          this.setData(response)
          this.showList = true
        })
      }
    },
    setData (response) {
      if (response) {
        this.items = response.items
        this.itemLinks = response.links
        // eslint-disable-next-line no-prototype-builtins
        if (
          this.itemLinks &&
          Object.keys(this.itemLinks).length > 1 &&
          this.itemLinks.hasOwnProperty('next')
        ) {
          if (this.pageNumbers >= 2) {
            this.pageNumbers = this.pagination.page + 1
          } else {
            this.pageNumbers = this.pagination.page - 1
          }
        }
        if (this.itemLinks && Object.keys(this.itemLinks).length === 1) {
          this.pageNumbers = this.pagination.page - 1
        }
      }
    },
    printPdfContent () {
      this.loaderEnabled = true
      // eslint-disable-next-line new-cap
      var pdf = new jsPDF('p', 'mm', 'A4')
      const element = document.getElementById('pdfLoanContent')
      html2canvas(element, {
        logging: true,
        letterRendering: true,
        allowTaint: false,
        useCORS: true,
        scale: (1920 * 2) / window.innerWidth,
        backgroundColor: '#fff'
      }).then((canvas) => {
        var image = canvas.toDataURL('image/jpeg', 0.3)
        pdf.setFontSize(14)
        pdf.text(38, 10, 'Loan Transactions \n')
        pdf.setFontSize(8)
        pdf.text(26, 15, `For the period from ${this.$formatter.formatDate(this.startDate)} to ${this.$formatter.formatDate(this.endDate)} (Page ${this.pagination.page})\n`)
        pdf.setFontSize(10)
        pdf.text(32, 20, `Loan Account Number: ${this.loanId}\n`)
        pdf.setFontSize(10)
        pdf.text(10, 24, '_________________________________________________')
        pdf.addImage(image, 'JPEG', 10, 26, 180, 0)
        pdf.save('LoanTransactions.pdf')
        this.loaderEnabled = false
      })
    },
    getDate (val) {
      return moment().subtract(parseInt(val), 'days').format('YYYY-MM-DD')
    },
    last3MonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(90)
      self.getCustomTransactions(startDate, endDate)
    },
    last6MonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(180)
      self.getCustomTransactions(startDate, endDate)
    },
    last9MonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(270)
      self.getCustomTransactions(startDate, endDate)
    },
    tenorTransactions () {
      // let numberOfDays
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      // const duration = this.loanConfig.loanTenor.split(' ')
      // switch (duration[1]) {
      //   case 'DAY':
      //     numberOfDays = duration[0]
      //     break
      //   case 'MONTH':
      //     numberOfDays = duration[0] * 30
      //     break
      //   default:
      //     numberOfDays = duration[0] * 365
      //     break
      // }
      // const startDate = self.getDate(numberOfDays)
      self.getCustomTransactions(self.loanConfig.loanStartDate, endDate)
    },
    thisMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(30)
      self.getCustomTransactions(startDate, endDate)
    },
    lastMonthTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(60)
      self.getCustomTransactions(startDate, endDate)
    },
    last15DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(15)
      self.getCustomTransactions(startDate, endDate)
    },
    last7DaysTransactions () {
      const self = this
      self.expandCustomList = false
      const endDate = self.currentDate
      const startDate = self.getDate(7)
      self.getCustomTransactions(startDate, endDate)
    },
    getItemGroup (items) {
      const self = this
      const groupResult = _.groupBy(items, function (item) {
        return self.$formatter.formatDate(item.valueDateTime.substr(0, 10))
      })
      self.itemGroups = groupResult
    },
    showCustomFilterList () {
      if (this.expandCustomList === true) {
        return (this.expandCustomList = false)
      }
      return (this.expandCustomList = true)
    }
  },
  watch: {
    dateError () {
      if (this.dateError) {
        this.items = []
      }
    },
    loanStartDateError () {
      if (this.loanStartDateError) {
        this.items = []
      }
    }
  }
}
</script>
